export default 'USER'